// extracted by mini-css-extract-plugin
module.exports = {"Layout":"_1WKx0cW0EyKqC1Mv7BZVSL"};